import * as LWP from "VSS/LWP";
import { IDashboardThrottlingService } from "Dashboards.Web/ms.vss-dashboards.dashboards-rate-limiter/DashboardThrottlingService";
import { FeatureAvailabilityService } from "VSS/FeatureAvailability/Services";
import { FeatureAvailabilityFlags } from "Presentation/Scripts/TFS/Generated/TFS.Server.WebAccess.Constants";

/* Indicates if monitoring is turned on. */
export function isMonitoringEnabled(): boolean {
    return FeatureAvailabilityService.isFeatureEnabled(FeatureAvailabilityFlags.WebAccessDashboardsMonitorResourceUtilizationHeaders, false);
}

/* When both header monitoring AND auto refresh suppression are enabled, throttling of refresh behavior and User facing experiences are provided. */
export function allowThrottling(): boolean {
    return isMonitoringEnabled() &&
        FeatureAvailabilityService.isFeatureEnabled(FeatureAvailabilityFlags.WebAccessDashboardsSuppressAutoRefreshOnHighResourceUtilization, false);
}

/**
 * Query the Dashboard Throttling service to see if the user is currently meets throttling bar, due to high resource usage. Requires Monitoring to be enabled.
 */
export function isAtHighUsage(): boolean {
    const throttlingService = LWP.getLWPService("IDashboardThrottlingService") as IDashboardThrottlingService;
    return throttlingService.getThrottlingState().isThrottled;
}
